
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Chart from "chart.js";
import { HorizontalBar, mixins } from "vue-chartjs";
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component
export default class HorizontalBarChart extends Mixins(
    HorizontalBar,
    mixins.reactiveProp
) {
  @Prop()
  chartData: any;
  @Prop()
  options: any;
  @Prop()
  dataLabel: any;

  mounted(): void {
    if (this.chartData) {
      this.dataLabel && this.addPlugin(ChartDataLabels)
      this.renderChart(this.chartData, this.options);
    }
  }
  @Watch("chartData")
  onChangeData(): void {
    if (this.chartData) {
      this.dataLabel && this.addPlugin(ChartDataLabels)
      this.renderChart(this.chartData, this.options);
    }
  }
}
